export default function TOS() {
    return (
      <div className="mx-auto p-4 w-screen h-screen bg-white">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      <p className="text-base mb-4"><strong>Effective Date:</strong> April 28, 2025</p>

      <p className="text-base mb-4">
        Welcome to STEM Enrichment of New Jersey ("we", "our", or "us"). By accessing or using our website located at nj.stemepa.com ("Site"), you agree to be bound by these Terms of Service. If you do not agree with any part of the terms, you must discontinue use of the Site.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">1. Use of Our Website</h2>
      <p className="text-base mb-4">
        Our Site is intended for informational and educational purposes. You may use our content for personal, non-commercial purposes. Unauthorized use of our materials for commercial purposes or misrepresentation is prohibited.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">2. Intellectual Property</h2>
      <p className="text-base mb-4">
        All content published on the Site, including text, graphics, logos, and other materials, are the property of STEM Enrichment of New Jersey unless otherwise noted. You may not reproduce, distribute, or create derivative works without prior written consent.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">3. User Conduct</h2>
      <p className="text-base mb-2">You agree not to:</p>
      <ul className="list-disc list-inside mb-4 space-y-2">
        <li>Violate any applicable laws</li>
        <li>Attempt to interfere with the security or proper functioning of the Site</li>
        <li>Use the Site to distribute spam, malware, or other harmful content</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">4. Third-Party Links</h2>
      <p className="text-base mb-4">
        Our Site may contain links to third-party websites or services. We are not responsible for the content, policies, or practices of these third parties.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">5. Disclaimer</h2>
      <p className="text-base mb-4">
        Our content is provided "as is" for general informational purposes only. We make no warranties regarding the accuracy, completeness, or reliability of the information.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">6. Limitation of Liability</h2>
      <p className="text-base mb-4">
        To the fullest extent permitted by law, STEM Enrichment of New Jersey is not liable for any indirect, incidental, or consequential damages arising from your use of the Site.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">7. Changes to Terms</h2>
      <p className="text-base mb-4">
        We may update these Terms of Service from time to time. Updates will be posted on this page with the effective date.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">8. Contact Us</h2>
      <p className="text-base mb-4">
        For questions about these Terms, please contact us at [insert your contact email].
      </p>
    </div>
      );
}